<template>
  <div class="publicItems">
    <div class="selectionArea">
      <!-- <el-button type="primary" icon="el-icon-search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left">重置</el-button> -->
      <el-button v-if="tableData.is_admin" type="primary" icon="el-icon-circle-plus" @click="dialogVisible = true">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="运营组id"
        />
        <el-table-column
          prop="operation_group_name"
          label="名称"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          v-if="tableData.is_admin"
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="primary" size="mini" @click="(drawer = true),(drawerItem = scope.row)">添加</el-button>
            <el-button type="warning" size="mini" @click="deleteMy(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改运营组' : '创建运营组'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.id = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">运营组名称</span>
          <el-input v-model="data.name" class="item_input" />
        </div>
      </div>
      <div style="display: flex; margin-top: 30px;justify-content: end;">
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      ref="drawer"
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
    >
      <Details v-if="drawer" :drawer-item="drawerItem" @close="$refs.drawer.closeDrawer()" />
    </el-drawer>
  </div>
</template>

<script>
import { getOperationGroupList, addOperationGroup, modifyOperationGroup, deleteOperationGroup } from '@/api/copyReleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10
      },
      data: {
        name: null,
        id: null
      },
      dialogVisible: false,
      drawer: false,
      drawerItem: {}
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getOperationGroupList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.data.name = row.operation_group_name
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name) {
        text = '请填写名称'
      }
      if (!text) {
        this.data.id ? await modifyOperationGroup(this.data) : await addOperationGroup(this.data)
      }
      this.$message({
        message: text || (this.data.id ? '更新成功' : '创建成功'),
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.name = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteOperationGroup(row.id)
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}
</style>
